import { render, staticRenderFns } from "./index.vue?vue&type=template&id=d028d1fc&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=d028d1fc&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d028d1fc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\workspace\\ysorder\\order_admin_client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d028d1fc')) {
      api.createRecord('d028d1fc', component.options)
    } else {
      api.reload('d028d1fc', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=d028d1fc&scoped=true", function () {
      api.rerender('d028d1fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/design/more/goods-source-manager/index.vue"
export default component.exports